<!-- eslint-disable -->
<template>
  <CommonPages id="terms" :class="['terms-page']" :titlePrefix="'Terms of Service'"
    :metaDescription="domainConfig?.['meta']?.des || 'Terms of Service and conditions of use'">
    <div class="privacy-full">
      <div class="privacy-full__container">
        <div class="privacy-full__content">
          <h1 class="privacy-full__title">Terms of Service</h1>
          <div class="privacy-full__body">
            <div class="privacy-section">
              <p class="privacy-section__text">
                Welcome to {{ domainConfig?.siteName }}. By accessing or using our website, you
                agree to comply with and be bound by the
                following terms and conditions.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">1. General Information</h2>
              <p class="privacy-section__text">
                The content provided on this website, including but not limited to articles,
                calculators, and other tools, is for
                informational purposes only. We aim to offer general data and insights that can
                assist you in making informed decisions.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">2. No Professional Advice</h2>
              <p class="privacy-section__text">
                The information on this website is not intended to be a substitute for professional
                advice. We do not provide financial,
                legal, or other professional services. You should consult with a qualified
                professional for advice tailored to your
                specific circumstances.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">3. Use of Tools</h2>
              <p class="privacy-section__text">
                Our website may include tools such as loan calculators and other financial
                estimators. These tools are designed to
                provide general guidance and estimates based on the data you input. The results are
                for reference only and should not be
                considered as guaranteed outcomes.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">4. Accuracy and Completeness</h2>
              <p class="privacy-section__text">
                While we strive to ensure the accuracy and completeness of the information on our
                website, we make no warranties or
                representations regarding its accuracy, reliability, or completeness. The use of
                this information is at your own risk.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">5. Limitation of Liability</h2>
              <p class="privacy-section__text">
                {{ domainConfig?.siteName }} will not be liable for any damages or losses arising
                from the use or inability to use our website or
                any information, tools, or services provided herein.
              </p>
            </div>

            <div class="privacy-section">
              <h2 class="privacy-section__title">6. Changes to Terms</h2>
              <p class="privacy-section__text">
                We reserve the right to modify these terms at any time. Any changes will be
                effective immediately upon posting on the
                website. Your continued use of the website constitutes acceptance of the revised
                terms.
              </p>
            </div>

            <div class="privacy-section">
              <p class="privacy-section__text">
                If you have any questions about these terms, please contact us at
                {{ domainConfig?.IAMEMAIL }}.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/common.scss';

export default {
  name: 'Terms',
  components: {
    CommonPages
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Terms] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Terms] Component mounted`);
    }
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Terms] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Terms] Component beforeDestroy`);
    }
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.privacy-full {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;
	margin: 0 0 rem(88);

	&__container {
		width: 100%;
		position: relative;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		padding: rem(88) rem(120);
		position: relative;
		z-index: 1;
	}

	&__title {
		color: #1a4048;
		font-size: rem(24);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__body {
		display: flex;
		flex-direction: column;
		gap: rem(36);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		align-self: stretch;
	}
}

.privacy-section {
	display: flex;
	flex-direction: column;
	gap: rem(16);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;
	align-self: stretch;

	&__title {
		color: #1a4048;
		font-size: rem(18);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: 0;
	}

	&__subtitle {
		color: #1a4048;
		font-size: rem(16);
		font-style: normal;
		font-weight: 500;
		line-height: rem(24);
		margin: rem(8) 0;
	}

	&__text {
		color: #1a4048;
		text-align: left;
		font-size: rem(16);
		line-height: rem(28);
		font-weight: 400;
		margin: rem(8) 0;
	}

	&__link {
		color: #1a4048;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	&__list,
	&__numbered-list {
		color: #1a4048;
		padding-left: rem(24);
		margin: rem(8) 0;

		li {
			margin-bottom: rem(10);
			line-height: rem(28);
			font-size: rem(16);

			strong {
				color: #1a4048;
				font-weight: 500;
				display: block;
				margin-bottom: rem(4);
			}
		}
	}

	&__numbered-list {
		counter-reset: section;
		list-style-type: none;
		padding-left: 0;

		> li {
			margin-bottom: rem(24);
			padding-left: rem(24);
			position: relative;

			&:before {
				counter-increment: section;
				content: counter(section) '.';
				position: absolute;
				left: 0;
				color: #1a4048;
				font-weight: 500;
			}
		}
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.privacy-full {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.privacy-full {
		&__content {
			width: 100%;
			padding: rem(40) rem(16);
		}

		&__title {
			font-size: rem(20);
			line-height: rem(20);
		}
	}

	.privacy-section {
		&__title {
			font-size: rem(16);
			line-height: rem(20);
		}

		&__subtitle {
			font-size: rem(14);
			line-height: rem(20);
		}

		&__text {
			font-size: rem(14);
			line-height: rem(24);
		}

		&__list,
		&__numbered-list {
			li {
				font-size: rem(14);
				line-height: rem(24);
			}
		}
	}
}
</style> 